<template>
<div class="Intro" v-show="isOpened">
  <VimeoPlayer videoUrl="https://player.vimeo.com/video/564267221" ref="vimeo" @ended="onEnded"/>
</div>
</template>

<script>
import VimeoPlayer from '@/components/VimeoPlayer'
import emitter from '@/emitter'

export default {
  data() {
    return { 
      isOpened: false,
    }
  },
  components: {
    VimeoPlayer,
  },
  inject: ['store'],
  methods: {
    applyConfig() {
      this.play = Object.assign(this.play, this.temp)
    },
    open() {
      this.isOpened = true;
      const player = this.$refs.vimeo;
      player.play();
      // this.onEnded()
    },
    onEnded() {
      this.isOpened = false
      this.store.start()
      emitter.emit('SOUND', true)
      emitter.emit('READY')
    }
	},
}
</script>

<style lang="stylus" scoped>
.Intro
  width 100%
  height 100vh
  position fixed
  z-index 100
  top 0
  left 0
  >>> .VimeoPlayer
    height 100vh
    background #000
    iframe
      height 100%
      width 100%

.ytp-show-cards-title.ytp-chrome-top
.ytp-chrome-top  
  display none !important
</style>